// Generated using scripts/write-decode-map.ts
export default new Uint16Array(
// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022"
    .split("")
    .map((c) => c.charCodeAt(0)));
//# sourceMappingURL=decode-data-xml.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/markdown-it/node_modules/entities/lib/esm/generated/decode-data-xml.js
// module id = null
// module chunks = 